import React from "react";

function CheckRoundIcon() {
  return (
    <span className="anticon anticon-checkround">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g stroke="currentColor" transform="translate(-469 -609)">
            <g transform="translate(469 609)">
              <path d="M8 .5c2.071 0 3.946.84 5.303 2.197A7.477 7.477 0 0115.5 8c0 2.071-.84 3.946-2.197 5.303A7.477 7.477 0 018 15.5a7.477 7.477 0 01-5.303-2.197A7.477 7.477 0 01.5 8c0-2.071.84-3.946 2.197-5.303A7.477 7.477 0 018 .5z"></path>
              <path
                strokeWidth="1.2"
                d="M4.5 8.5L7.28312732 10.8638898 11.9964968 5.15505513"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}

export default CheckRoundIcon;
